import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getTopBarStyleObject } from './topBar.style';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../common/hooks/useStyles';
import { Icon } from '../../../common/components/icon/icon';
import { CONTROLS_ICON_TYPES } from '../icon/iconMapper';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';
import { css } from '../../../common/styles/styles.utils';
import { getShareId, getTopBarId } from '../htmlElements/htmlElementsIdGetter';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { LogoAndTitle } from './logoAndTitle/logoAndTitle';
import { anchorOptionsSelector } from '../../../common/store/selectors/anchorOptions.selector';
import { isEmpty } from '../../../common/utils/utils';
import { anchorDataSelector } from '../../../common/store/selectors/anchorData.selector';

interface TopBarComponentVariablesProps {
  clickToPlayMode: boolean;
}

export const TopBar: FunctionComponent<TopBarComponentVariablesProps> = props => {
  const { clickToPlayMode } = props;

  const playerSize = useSelector(playerDataSelector.playerSize);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const showControls = useSelector(playerDataSelector.showControls);
  const canClose = useSelector(anchorOptionsSelector.canClose);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);

  const isAnchored = anchorStatus === 'active';
  const showCloseBar = isAnchored && canClose && isEmpty(splitViewRatio);
  const showAdControls = isVastAd && adBreak;
  // const showShareIcon = !anchorActive && !showAdControls && (playerSize === 'large' || playerSize === 'extraLarge') && playbackMethod !== 'none'; // FOR THE NEXT VERSION
  const showShareIcon = false;
  const isTopBarVisible = !clickToPlayMode && showControls;

  const styles = useStyles(getTopBarStyleObject, [isTopBarVisible, playerSize, showAdControls, splitViewRatio, showCloseBar]);
  const { topBarContainerStyle, shareIconStyle } = styles;

  const ShareIcon: FunctionComponent = () => (
    showShareIcon ?
      <Icon icon={CONTROLS_ICON_TYPES.SHARE_FILL} style={shareIconStyle} id={getShareId(playerUniqueId)} /> : null
  );

  return (
    <div
      style={css(topBarContainerStyle)}
      id={getTopBarId(playerUniqueId)}
      onClick={(e): void => e.stopPropagation()}
    >
      <LogoAndTitle />
      <ShareIcon />
    </div>
  );
};
